import React, { useEffect } from 'react';
import { useRouteError, isRouteErrorResponse } from 'react-router-dom';

export const RouteErrorBoundary: React.FC = () => {
  const error = useRouteError();
  let errorMessage = 'Произошла непредвиденная ошибка при загрузке страницы.';
  let isChunkOrInvariant306 = false;

  if (isRouteErrorResponse(error)) {
    errorMessage = `${error.status} ${error.statusText}: ${error.data || 'Страница не найдена или не доступна'}`;
  } else if (error instanceof Error) {
    errorMessage = error.message;
    if (
      errorMessage.includes('#306') ||
      errorMessage.includes('Element type is invalid') ||
      errorMessage.includes('Failed to fetch dynamically imported module') ||
      errorMessage.includes('Importing a module script failed')
    ) {
      isChunkOrInvariant306 = true;
      errorMessage = 'Файлы компонента были обновлены на сервере. Обновляем страницу...';
    }
  }

  useEffect(() => {
    if (isChunkOrInvariant306) {
      const key = 'ep_auto_reload_306';
      const hasRetried = sessionStorage.getItem(key);
      if (!hasRetried) {
        sessionStorage.setItem(key, 'true');
        window.location.reload();
      } else {
        setTimeout(() => sessionStorage.removeItem(key), 5000);
      }
    }
  }, [isChunkOrInvariant306]);

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] p-6 text-center">
      <div className="bg-red-50 border border-red-200 rounded-xl p-8 max-w-lg w-full shadow-sm">
        <h2 className="text-xl font-semibold text-red-700 mb-2">
          {isChunkOrInvariant306 ? 'Обновление страницы' : 'Ошибка при загрузке страницы'}
        </h2>
        <p className="text-sm text-red-600 mb-6">{errorMessage}</p>
        <button
          onClick={() => {
            sessionStorage.removeItem('ep_auto_reload_306');
            window.location.reload();
          }}
          className="px-4 py-2 bg-red-600 hover:bg-red-700 text-white font-medium rounded-lg transition-colors text-sm"
        >
          Обновить страницу
        </button>
      </div>
    </div>
  );
};

export default RouteErrorBoundary;
